var map = {
	"./goldcoin/index-btn-mine.png": 50317,
	"./memetown/index-btn-mine.png": 31242,
	"./reflection/index-btn-mine.png": 71730,
	"./tapcoin/index-btn-mine.png": 6368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47460;